var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fontFamily)?_c('v-app',{style:('--fontFamily: ' + _vm.fontFamily.value),attrs:{"dark":_vm.darkMode,"id":"inspire"}},[_c('v-container',{staticClass:"pa-0"},[_c('AppHeader'),_c('v-content',[_c('router-view',{})],1)],1),_c('AppFooter')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }